import { useQuery } from "@tanstack/react-query";
import { useAuth, useOrganization } from "@clerk/clerk-react";
import { useApi } from "../services/api/api-service";
import { useActiveAgent } from "../contexts/ActiveAgentContext";

export interface IDashboardStats {
  totalMinutesUsed: number;
  totalUniqueCallers: number;
  totalOrders?: number;
  totalRevenue?: number;
  callsLast7Days: Array<{ date: string; count: number }>;
}

export function useDashboardStats() {
  const { getToken } = useAuth();
  const { organization: activeOrg } = useOrganization();
  const { activeAgent, agentsLoading: isLoadingAgent } = useActiveAgent();
  const agentRequired = true;
  const homeApi = useApi(agentRequired);

  return useQuery<IDashboardStats>({
    queryKey: ["dashboard-stats", activeOrg?.id, activeAgent?.id],
    queryFn: async () => {
      return homeApi.get<IDashboardStats>("/analytics");
    },
    retry: false,
    enabled:
      !isLoadingAgent &&
      !!getToken() &&
      !!activeOrg &&
      !!activeOrg.id &&
      !!activeAgent?.id,
    staleTime: 60 * 60 * 1000, // 1 hour - data is considered fresh for 1 hour
    refetchInterval: 60 * 60 * 1000, // 1 hour - refetch every hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours - keep in cache for 2 hours
    refetchOnWindowFocus: false,
  });
}
